var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondFloor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 664.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First_Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "744.192 309.326 1012.096 154.69 1012.096 131.773 744.192 286.409 744.192 309.326",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "734.27 280.675 1002.173 126.044 1012.096 131.773 744.192 286.409 734.27 280.675",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "962.482 343.741 1002.181 320.839 1012.096 326.563 972.406 349.47 962.482 343.741",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1012.096 326.563 1012.096 349.486 912.869 406.774 912.869 383.855 1012.096 326.563",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1012.096 326.563 1101.397 378.131 1101.397 401.047 1012.096 349.486 1012.096 326.563",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1002.181 320.839 1012.096 315.105 1111.32 372.397 1101.397 378.131 1002.181 320.839",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1012.096 131.773 1260.155 275.004 1260.155 297.92 1012.096 154.688 1012.096 131.773",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1002.173 126.044 1012.096 120.311 1270.078 269.27 1260.155 275.004 1002.173 126.044",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1101.397 401.047 1280 297.915 1280 274.999 1101.397 378.131 1101.397 401.047",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "744.187 286.533 734.27 280.675 734.27 303.632 744.192 309.326 744.187 286.533",
    fill: "#a5a5a5"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "357.301 85.885 367.529 80.602 380.666 85.935 456.449 143.224 357.301 85.885",
    fill: "#4a2a3f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.908 17.195 396.903 97.399 386.984 103.027 386.984 22.922 386.98 22.918 396.908 17.195",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1190.7,
    cy: 321.625,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.973 7.394) rotate(-.356)",
    fill: "#6d4861"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.809,
    y: 309.37,
    width: 3.785,
    height: 12.256,
    fill: "#6d4861"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "992.209 452.63 893.093 509.974 773.968 441.147 823.57 412.506 823.574 349.498 842.658 360.561 842.658 360.554 844.172 359.679 844.172 361.318 853.343 366.636 853.343 383.858 863.264 389.588 873.188 383.858 992.209 452.63",
    fill: "#4a2a3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.595,314.013v-4.644c0-.28-.186-.556-.553-.768-.734-.424-1.934-.42-2.676,.008-.394,.227-.583,.53-.556,.829v6.76l-85.548,49.398v-4.663c0-.276-.182-.556-.549-.768-.738-.424-1.934-.42-2.676,.008-.367,.212-.553,.484-.56,.761v4.625l-85.488-49.356v-6.828c.027-.299-.159-.598-.549-.821-.734-.428-1.934-.424-2.676,.004-.394,.227-.583,.53-.556,.829v6.813l-8.024,4.64-39.697,22.903-79.375-45.821h-.004l-9.924-5.73-4.962,2.865-14.879,8.596v62.986l-9.171-5.318v-1.639l-1.514,.874v.008l-19.084-11.063v-17.203l-.034-.019,.034-.019-4.966-2.865-14.879-8.584-39.687-22.889,248.055-143.23,228.215,131.77-47.717,27.555Z",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.594,309.37v.004c0,.28-.189,.56-.56,.776-.742,.428-1.942,.428-2.676,.004-.344-.201-.53-.454-.549-.715v-.068h.006c.006-.276,.186-.551,.55-.761,.742-.428,1.942-.431,2.676-.008,.367,.212,.553,.488,.553,.768Z",
    fill: "#6d4861"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "813.646 349.509 823.568 343.755 823.571 263.544 813.646 269.3 813.646 349.509",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.984 22.922 386.984 103.027 377.056 97.293 367.139 91.566 367.139 11.465 377.056 17.188 386.98 22.918 386.984 22.922",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "415.989 34.001 391.94 20.057 396.901 17.192 420.95 31.137 415.989 34.001",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.989 114.211 391.94 100.266 391.94 20.057 415.989 34.001 415.989 114.211",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.988 114.2 415.988 34.002 420.95 31.137 420.95 111.335 415.988 114.2",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "842.659 280.353 818.61 266.409 823.571 263.544 847.62 277.489 842.659 280.353",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "842.658 280.354 842.658 360.561 823.574 349.498 818.608 346.617 818.608 266.41 842.658 280.354",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "847.62 277.488 847.62 357.688 844.172 359.679 842.658 360.554 842.658 280.354 847.62 277.488",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "868.223 295.055 844.174 281.11 849.135 278.246 873.184 292.19 868.223 295.055",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "868.222 295.055 868.222 375.266 853.343 366.636 844.172 361.318 844.172 281.111 847.62 283.109 868.222 295.055",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "868.222 375.254 868.222 295.056 873.183 292.19 873.183 372.389 868.222 375.254",
    fill: "#a3673e"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "426.665 34.379 416.742 40.116 813.677 269.257 823.571 263.544 426.665 34.379",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "426.658 57.294 431.619 54.428 808.73 272.118 808.73 329.411 803.769 332.276 426.658 114.586 426.658 57.294",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "803.74 332.263 426.657 114.586 431.618 111.721 808.702 329.398 803.74 332.263",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "803.74 274.983 426.657 57.306 431.618 54.441 808.702 272.118 803.74 274.983",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.658 114.586 426.658 57.294 431.619 54.428 431.619 111.721 426.658 114.586",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "803.769 332.276 803.769 274.983 808.73 272.118 808.73 329.411 803.769 332.276",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "813.692 269.361 813.692 280.822 416.742 51.582 416.742 40.117 813.692 269.361",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "813.692 338.005 813.692 349.466 416.742 120.226 416.742 108.761 813.692 338.005",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "813.692 269.361 813.692 349.372 803.764 343.637 803.764 263.627 813.692 269.361",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.67 45.851 426.67 125.862 416.742 120.128 416.742 40.117 426.67 45.851",
    fill: "#694960"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.908 17.195 386.98 22.918 377.056 17.188 367.139 11.465 357.211 5.73 367.132 0 377.056 5.73 386.984 11.465 396.908 17.195",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "793.805 257.841 416.764 40.121 416.764 40.113 793.805 257.841",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.588 504.171 773.965 383.861 773.967 303.65 565.588 423.962 565.588 504.171",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.923 297.923 367.135 91.668 367.138 11.457 9.923 217.713 9.923 297.923",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 211.984 9.923 217.713 367.138 11.457 357.213 5.726 0 211.984",
    fill: "#fae6b4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "764.037 389.596 764.028 309.377 813.628 337.998 813.607 418.219 764.037 389.596",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "615.199 532.817 823.569 412.507 823.572 332.296 615.199 452.608 615.199 532.817",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "605.277 446.879 615.199 452.608 615.199 532.817 605.277 527.088 605.277 446.879",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "863.26 389.587 883.104 378.131 883.107 297.92 863.26 309.377 863.26 389.587",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "853.338 303.648 863.26 309.377 883.107 297.92 873.182 292.189 853.338 303.648",
    fill: "#fae6b4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "823.561 481.254 823.561 550.005 813.639 544.276 813.639 475.525 823.561 481.254",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "823.561 550.005 813.639 544.276 704.492 607.297 714.471 613.059 823.561 550.005",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "694.58 487.588 694.58 407.376 823.563 481.243 823.542 561.464 694.58 487.588",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684.642 401.047 823.544 481.255 833.488 475.514 694.58 395.31 684.642 401.047",
    fill: "#fae6b4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "873.183 383.859 873.183 303.647 1002.181 378.116 1002.16 458.337 873.183 383.859",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1091.475 372.397 1270.078 269.27 1280 274.999 1101.397 378.131 1091.475 372.397",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.665 418.233 565.588 423.962 773.967 303.65 764.042 297.919 555.665 418.233",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.664 418.233 565.587 423.963 565.587 504.171 555.664 498.442 555.664 418.233",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "853.339 303.648 863.262 309.377 863.262 389.586 853.339 383.857 853.339 303.648",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "754.11 303.656 813.628 337.998 823.572 332.256 764.048 297.919 754.11 303.656",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1012.096,
    cy: 321.63,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.976 6.286) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010.204,
    y: 309.318,
    width: 3.784,
    height: 12.312,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1012.096,
    cy: 309.326,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.9 6.286) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 843.415,
    cy: 224.158,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.375 5.238) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.524,
    y: 211.973,
    width: 3.784,
    height: 12.185,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 843.415,
    cy: 211.98,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.299 5.237) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1101.368,
    cy: 373.192,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-2.294 6.841) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1099.476,
    y: 360.933,
    width: 3.784,
    height: 12.259,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1101.368,
    cy: 360.94,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-2.218 6.841) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1190.699,
    cy: 321.624,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.973 7.394) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.807,
    y: 309.37,
    width: 3.784,
    height: 12.254,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1190.699,
    cy: 309.377,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.897 7.394) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 932.717,
    cy: 172.663,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.053 5.791) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930.825,
    y: 160.41,
    width: 3.784,
    height: 12.253,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 932.717,
    cy: 160.417,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-.977 5.79) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1270.078,
    cy: 275.795,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.687 7.886) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268.186,
    y: 263.536,
    width: 3.784,
    height: 12.259,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1270.078,
    cy: 263.543,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.611 7.886) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1180.776,
    cy: 224.164,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.368 7.331) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1178.885,
    y: 211.973,
    width: 3.784,
    height: 12.191,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1180.776,
    cy: 211.98,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.293 7.331) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1101.397,
    cy: 178.398,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.086 6.837) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1099.506,
    y: 166.139,
    width: 3.784,
    height: 12.259,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1101.397,
    cy: 166.146,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-1.01 6.837) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1012.107,
    cy: 126.833,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-.767 6.282) rotate(-.356)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010.215,
    y: 114.576,
    width: 3.784,
    height: 12.257,
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1012.107,
    cy: 114.583,
    rx: 1.893,
    ry: 1.093,
    transform: "translate(-.691 6.282) rotate(-.356)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "694.582 487.589 823.561 561.464 645.04 664.182 9.71 297.687 367.139 91.668 367.139 91.57 377.056 97.297 396.908 108.765 744.226 309.362 555.669 418.233 555.666 418.233 555.666 498.444 565.59 504.171 605.279 481.257 605.279 527.089 615.203 532.819 694.582 486.987 694.582 487.589",
    fill: "#4a2a3f"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "790.959 242.919 1012.107 114.583 1270.078 263.543 1101.418 360.924 1012.096 309.326 953.939 344.207",
    fill: "none",
    stroke: "#999",
    strokeLinejoin: "round",
    strokeWidth: 3.028
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "873.183 303.647 1002.163 378.128 1012.106 372.387 883.108 297.918 873.183 303.647",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.923 206.247 0 211.984 644.957 584.381 654.852 578.668 9.923 206.247",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.916 229.162 14.877 226.297 640.011 587.242 640.011 644.534 635.049 647.399 9.916 286.454 9.916 229.162",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.021 647.386 9.915 286.454 14.876 283.59 639.983 644.522 635.021 647.386",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.021 590.106 9.915 229.174 14.876 226.31 639.983 587.242 635.021 590.106",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.916 286.454 9.916 229.162 14.877 226.297 14.877 283.589 9.916 286.454",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.049 647.399 635.049 590.107 640.011 587.242 640.011 644.534 635.049 647.399",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "644.972 584.484 644.972 595.945 0 223.45 0 211.985 644.972 584.484",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.972 653.129 644.972 664.59 0 292.095 0 280.63 644.972 653.129",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.972 584.484 644.972 664.495 635.044 658.761 635.044 578.75 644.972 584.484",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.928 217.72 9.928 297.73 0 291.996 0 211.985 9.928 217.72",
    fill: "#fcb76c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "823.561 492.68 818.6 489.815 709.453 552.836 709.453 610.128 714.414 612.993 823.561 549.973 823.561 492.68",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.442 612.98 823.562 549.973 818.601 547.108 709.481 610.116 714.442 612.98",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.442 555.7 823.562 492.693 818.601 489.828 709.481 552.836 714.442 555.7",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "823.561 549.973 823.561 492.68 818.6 489.815 818.6 547.108 823.561 549.973",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.414 612.993 714.414 555.701 709.453 552.836 709.453 610.128 714.414 612.993",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "982.323 401.037 977.361 398.172 868.214 461.193 868.214 518.486 873.176 521.351 982.323 458.33 982.323 401.037",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "873.204 521.338 982.323 458.33 977.362 455.465 868.242 518.473 873.204 521.338",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "873.204 464.058 982.323 401.05 977.362 398.185 868.242 461.193 873.204 464.058",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "982.323 458.33 982.323 401.037 977.361 398.172 977.361 455.465 982.323 458.33",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "873.176 521.351 873.176 464.058 868.214 461.193 868.214 518.486 873.176 521.351",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "714.471 624.453 833.474 555.728 833.484 544.276 714.471 613.059 714.471 624.453",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "893.093 452.563 1012.096 383.839 1012.106 372.387 893.093 441.17 893.093 452.563",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.471 555.702 833.474 486.978 833.484 475.525 714.471 544.309 714.471 555.702",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "893.093 521.368 1012.096 452.643 1012.106 441.191 893.093 509.974 893.093 521.368",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.957 584.381 714.471 544.309 714.471 624.452 644.957 664.59 644.957 584.381",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "823.561 481.255 893.075 441.182 893.075 521.326 823.561 561.464 823.561 481.255",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1012.108 372.385 1012.108 452.529 982.35 469.712 982.35 389.539 1012.108 372.385",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1002.163 366.67 635.035 578.651 644.957 584.381 1012.106 372.387 1002.163 366.67",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "605.277 446.879 615.199 452.608 823.572 332.296 813.647 326.565 605.277 446.879",
    fill: "#fae6b4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondFloor);
export default __webpack_public_path__ + "static/media/second-floor.8bc77e44c477bc8ab57268a2c104ce19.svg";
export { ForwardRef as ReactComponent };